import React from 'react';
import { TierBadge as SharedTierBadge } from '../../../shared/TierBadge';

export function TierBadge({ determinism }: { determinism?: string }) {
    return <SharedTierBadge determinism={determinism} />;
}

export default TierBadge;
